<svg
  xmlns="http://www.w3.org/2000/svg"
  width="28"
  height="28"
  fill="none"
  class="user-select-none cursor-pointer"
  viewBox="0 0 26 26">
  <path
    fill="#fff"
    d="M11.204 2.276c.92-.791 2.28-.791 3.201 0a2.457 2.457 0 0 0 2.152.53 2.457
    2.457 0 0 1 2.835 1.488 2.457 2.457 0 0 0 1.66 1.47 2.457 2.457 0 0 1 1.818
    2.634c-.082.777.21 1.546.786 2.073a2.457 2.457 0 0 1 .386 3.178 2.457 2.457
    0 0 0-.267 2.2 2.457 2.457 0 0 1-1.136 2.994 2.457 2.457 0 0 0-1.259 1.824
    2.457 2.457 0 0 1-2.396 2.123c-.78.012-1.51.394-1.963 1.03a2.457 2.457 0 0
    1-3.108.766 2.457 2.457 0 0 0-2.216 0 2.457 2.457 0 0 1-3.109-.766 2.457
    2.457 0 0 0-1.963-1.03 2.457 2.457 0 0 1-2.396-2.123 2.457 2.457 0 0
    0-1.259-1.824 2.457 2.457 0 0 1-1.135-2.994 2.457 2.457 0 0 0-.267-2.2 2.457
    2.457 0 0 1 .386-3.178 2.457 2.457 0 0 0 .785-2.073 2.457 2.457 0 0 1
    1.82-2.634 2.457 2.457 0 0 0 1.658-1.47 2.457 2.457 0 0 1
    2.835-1.488c.76.175 1.56-.022 2.152-.53Z" />
  <circle cx="12.806" cy="13.401" r="8.053" fill="#fff" stroke="#45B36B" />
  <path
    fill="#45B36B"
    d="M11.85 13.825h.869c.795 0 1.279.39 1.279 1.035 0 .596-.518 1.01-1.255
    1.01-.777 0-1.265-.39-1.309-.986h-1.41c.068 1.3 1.108 2.173 2.7 2.173 1.625
    0 2.773-.84 2.773-2.104 0-.977-.679-1.612-1.729-1.7v-.029c.864-.156
    1.455-.781 1.455-1.645 0-1.128-1-1.88-2.466-1.88-1.528 0-2.543.85-2.597
    2.153h1.357c.04-.615.494-1.02 1.177-1.02.732 0 1.138.375 1.138.947 0
    .58-.454.981-1.128.981h-.855v1.065Z" />
</svg>
